import { render } from "./Biometria.vue?vue&type=template&id=3fe782d2&scoped=true"
import script from "./Biometria.vue?vue&type=script&lang=js"
export * from "./Biometria.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=3fe782d2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe782d2"]])

export default __exports__